import { CSSObject } from '@emotion/react';
import { useHoneycombTheme } from '../../theming';

type StyleClasses = 'input';

export function useStyles(): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();
    const { interaction } = theme;

    const input: CSSObject = {
        '&:disabled + [data-surface]': {
            opacity: interaction.disabledOpacity,
        },
        '&:focus-visible + [data-surface]': {
            ...theme.focusRingStyles.styles(theme),
        },
    };

    return {
        styles: {
            input,
        },
    };
}
